var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK13DPrinting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 56.49L52 50.81V63H39.5v-6.51zm-15.17-8.66L38 53.88 44.32 51l.35-.15 4.76-2.1h-.14l2-.92h.08l-13.48-5-13.56 5zM68 10v56a4.21 4.21 0 01-4 4H12a4.18 4.18 0 01-4-4V10a4.23 4.23 0 014-4h52a4.3 4.3 0 014 4zM12 27h21v-3.91h3.5v-3.36A3.73 3.73 0 0140.23 16h14.92a.73.73 0 00.73-.73V10H12v17zm52 3H43v4h-3v4l-2 2-2-2v-4h-3v-4H12v36h52V30zm0-20h-5.12v5.27A3.73 3.73 0 0155.15 19H40.23a.73.73 0 00-.73.73v3.36H43V27h21V10zM24 62.94h12.5V56.5L24 51.09v11.85z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_3D_printing.249c72c9.svg";
export { SvgK13DPrinting as ReactComponent };